import React from "react";
import MainContent from "../../../../widgets/templates/main_content";
import Table from "./table";
import { paths } from "../../../app_modules";
import AdminHeader from "../../../../widgets/templates/admin_header";

function ProcedureGroupPage(){

    return(
        <MainContent>
            <AdminHeader 
                title="Grupos de procedimiento" 
                masivPath={paths.procedure_group_form} 
                createPath={paths.procedure_group_form} 
            />
            <hr />
            <div style={{ width: '100%' }}>
                <Table />
            </div>
        </MainContent>
    );
}

export default ProcedureGroupPage;